module.exports = __webpack_public_path__ + "img/ico-url.354e487f.svg";